export const DesignationEnum = {
  SENIOR_SOLUTION_CONSULTANT: "SENIOR_SOLUTION_CONSULTANT",
  QA: "QA",
  SALESFORCE_LEAD: "SALESFORCE_LEAD",
  BUSINESS_ANALYST: "BUSINESS_ANALYST",
  SENIOR_DEVELOPER: "SENIOR_DEVELOPER",
  PROJECT_MANAGER: "PROJECT_MANAGER",
  LEAD_ARCHITECT_MULESOFT: "LEAD_ARCHITECT_MULESOFT",
  SOLUTION_ARCHITECT_MULESOFT: "SOLUTION_ARCHITECT_MULESOFT",
  LEAD_ARCHITECT_RPA: "LEAD_ARCHITECT_RPA",
  SOLUTION_ARCHITECT_RPA: "SOLUTION_ARCHITECT_RPA",
  LEAD_BUSINESS_ANALYST: "LEAD_BUSINESS_ANALYST",
  SOLUTION_ARCHITECT_INFORMATICA: "SOLUTION_ARCHITECT_INFORMATICA",
  PROGRAM_MANAGER: "PROGRAM_MANAGER",
};
